import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-tile text-neutral2-500 px-2 md:px-4 pt-4 border-t md:border border-tile-border md:rounded-lg" }
const _hoisted_2 = { class: "flex justify-between font-medium text-sm" }
const _hoisted_3 = {
  href: "/User/Notifications",
  class: "text-green2-500"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "xs:flex xs:justify-between text-sm" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = {
  key: 0,
  class: "text-center py-8"
}

import {onMounted} from "vue";
import {Notification} from "../../../../../Domain/Navigation/Notification";
import Icon from "../../../Icon/Icon.vue";

interface Props {
  notifications: Notification[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationBox',
  props: {
    notifications: {}
  },
  emits: ['markAll', 'loadMore'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

onMounted(() => {
  if (props.notifications.length === 0) {
    loadMore();
  }
});

function markAllAsViewed(): void {
  emit('markAll');
}

function loadMore(): void {
  emit('loadMore');
}

function scroll(event: Event): void {
  if (scrolledToBottom(event)) loadMore();
}

function scrolledToBottom(event: Event): boolean {
  const element: HTMLElement = event.target;
  const distanceToBottom = Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight);
  return distanceToBottom < 1;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _cache[0] || (_cache[0] = _createTextVNode(" Powiadomienia ")),
        _createVNode(Icon, { name: "notificationSeeAll" })
      ]),
      _createElementVNode("span", {
        class: "md:cursor-pointer",
        textContent: 'Oznacz jako przeczytane',
        onClick: markAllAsViewed
      })
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "text-tile-border mt-3" }, null, -1 /* CACHED */)),
    _createElementVNode("div", {
      class: "h-130 py-3 overflow-y-scroll",
      onScrollPassive: scroll
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.notifications, (notification) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["px-3 py-2.5 mb-1 flex rounded-lg", {'text-green2-600 bg-green2-100 dark:text-neutral2-600 dark:bg-tile-nested':notification.notificationHighlighted}])
        }, [
          _createElementVNode("a", {
            class: "size-10 rounded user-avatar flex-shrink-0 mt-0.5",
            href: notification.actorProfileHref
          }, [
            (notification.actorAvatarUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: notification.actorAvatarUrl,
                  class: "rounded size-10 object-cover"
                }, null, 8 /* PROPS */, _hoisted_5))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  textContent: _toDisplayString(notification.actorInitials),
                  class: "text-center leading-10 border border-green2-300 rounded"
                }, null, 8 /* PROPS */, _hoisted_6))
          ], 8 /* PROPS */, _hoisted_4),
          _createElementVNode("a", {
            class: "ml-3 min-w-0 flex-grow-1",
            href: notification.contentHref
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "flex items-center order-1 xs:order-3",
                textContent: _toDisplayString(notification.notificationDate)
              }, null, 8 /* PROPS */, _hoisted_9),
              _createElementVNode("div", {
                textContent: _toDisplayString(notification.notificationTitle),
                class: "order-2"
              }, null, 8 /* PROPS */, _hoisted_10)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["truncate font-medium text-green2-500", notification.notificationHighlighted ? '' : 'dark:text-neutral2-600']),
              textContent: _toDisplayString(notification.contentTitle)
            }, null, 10 /* CLASS, PROPS */, _hoisted_11),
            _createElementVNode("div", {
              textContent: _toDisplayString(notification.contentPreview),
              class: "truncate text-sm w-17/20"
            }, null, 8 /* PROPS */, _hoisted_12)
          ], 8 /* PROPS */, _hoisted_7)
        ], 2 /* CLASS */))
      }), 256 /* UNKEYED_FRAGMENT */)),
      (props.notifications.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Nie masz żadnych powiadomień. "))
        : _createCommentVNode("v-if", true)
    ], 32 /* NEED_HYDRATION */)
  ]))
}
}

})